<template>
  <div class="limit_left">
    <div
      v-if="!noShowHeader"
      class="limite_header"
      style="height: 50px;"
    >
      <div
        class="blue_header"
        style="width:50%; height: 100%;"
      >
        <template v-if="onlySelectOne">
          <span style="line-height: 50px;">
            {{ $t('scene.blockOneSelect') }} {{ treeCheckedArea }}
          </span>
        </template>
        <template v-else>
          <span :style="(treeCheckedArea!=null && treeCheckedArea != '')?'':'line-height: 50px;'">
            {{ $t('scene.blockMoreSelect') }}
          </span>
          <span
            v-if="treeCheckedArea!=null && treeCheckedArea != ''"
            style="opacity: 0.3;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;width: 100%;margin-top: 3px;"
          >{{ treeCheckedArea }}</span>
        </template>
      </div>
      <div
        class="search_limit"
        style="width:40%;"
      >
        <div
          class="search_box"
          style="width:100%;"
        >
          <span class="input input--kaede">
            <input
              id="input-35"
              v-model="filterText"
              class="input__field input__field--kaede"
              type="text"
            >
            <label
              class="input__label input__label--kaede"
              for="input-35"
            >
              <span class="input__label-content input__label-content--kaede"><i class="el-icon-search text-button" /></span>
            </label>
          </span>
        </div>
      </div>
    </div>
    <div class="limit_body">
      <vuescroll>
        <div class="limit_tree_cont">
          <div class="ly-tree-container">
            <!-- default-expand-all -->
            <div v-if="showCancelChoose" class="cancel_select_div" @click="cancelSelect">
              {{ $t('otatask.resumeOperate') }}
            </div> 
            <el-tree
              ref="tree"
              v-loading="isloading"
              :check-strictly="true"
              :data="treeData"
              show-checkbox
              node-key="id"
              :default-checked-keys="checkedarea"
              :filter-node-method="filterNode"
              highlight-current
              :props="defaultProps"
              auto-expand-parent
              :default-expanded-keys="expandedarea"
              @check="handleCheckChange"
              @check-change="roleUseCheckChange"
            />
            <!-- :default-expanded-keys="expandedarea" -->
          </div>
        </div>
      </vuescroll>
      <div
        v-if="isShowCheckedMaxTips"
        class="warmfont"
        style="line-height: 25px;text-align: right;"
      >
        {{ showCheckedMaxTips() }}
      </div>
    </div>
  </div>
</template>

<script>
import vuescroll from 'vuescroll';
import { FindUserAreaTree, FindArea } from '@/axios/IArea';
export default {
	components: {
		vuescroll
	},
	props:['checkedarea', 'onlySelectOne', 'areaid', 'areaSelf','checkedMaxLenght','checkedMaxTips','limitLevel','limitAreaids','noSupportCrossLevel','noShowHeader', 'singleSelect','isShowAllArea', 'filterGpNo','showCancelChoose'],
	data() {
		return {
			filterText: '', //树形关键字搜索
			defaultProps: {
				children: 'children',
				label: 'label'
			}, //赋值树控件关键字
			treeData:[], //数据树
      isloading:true, //是否加载
      expandedarea:[],
      areaSelfOn:false,
      isShowCheckedMaxTips:false,
      treeCheckedArea: '',
      LevelMap:{
        1:this.$t('energyBoard.city'),
        2:this.$t('energyBoard.building'),
        3:this.$t('energyBoard.floor'),
        4:this.$t('energyBoard.room'),
      }
		};
	},
	watch: {
		filterText(val) {
			this.$refs.tree.filter(val);
		},
	},
	mounted() {
    this.treeCheckedArea = '';
    this.doFindUserAreaTree(this.areaid);
	},
	methods: {
    //取消选择
    cancelSelect(){
      // this.$refs.tree.setCheckedKeys([]);
      this.dealTreeOnceChecked(this.treeData, false, this);
      this.updataAreaList()
    },
    refresh(){
      this.$refs.tree.refresh();
    },
    showCheckedMaxTips(){
      if(this.checkedMaxTips != null){
        return this.checkedMaxTips;
      }
      var param = this.$t('scene.blockSelectLimitTips');
      if(param.indexOf('#')>=0){
        param = param.split('#');
        if(param.length == 3){
          param = param[0] + this.checkedMaxLenght + param[2];
          return param;
        }
      }
      return this.$t('scene.blockSelectLimitTips');
    },
		/* 递归获得树形数据
		* rs:接口返回的数据包
		*/
		functionDoFindUserAreaTree(rs) {
			//console.log(rs);
      this.treeData = [];
      this.expandedarea = [];
			if (rs.StatusCode == 0 && rs.Result != null) {
				if (rs.Result instanceof Array && rs.Result.length > 0) {
          // console.log('2891748947', rs.Result);
          let filterList = [];

          // 过滤gpNo
          if (this.filterGpNo === true) {
            this.treeFilter(rs.Result.slice(), filterList);
          }

          let list = filterList.length ? filterList : rs.Result;

					list.forEach((item, index) => {
						this.addArry(item, this.treeData,false);
					});
				}else{
          this.addArry(rs.Result, this.treeData,false);
        }
        if(this.isShowAllArea){
          this.treeData = [{
            id: -1,
            label: this.$t('home.allArea'),
            Level: 0,
            IsLeaf: false,
            children: [...this.treeData]
          }]
        }

			}
      this.isloading = false;
      
      setTimeout( this.setOnlySelectOneObj ,100);
    },
    setOnlySelectOneObj(){
      this.isShowCheckedMaxTips = false;
      var _checkedarea = this.getTreeChecked();
      if(_checkedarea != null && _checkedarea.length>0){
        this.expandedarea = [];
        _checkedarea.forEach( param => {
          if(param["id"] != null){this.expandedarea.push(param["id"]);}
        });

        if(this.onlySelectOne == true ){
          // if(this.checkedarea.length>1){_checkedarea = [this.checkedarea[0]];}
          // _checkedarea = this.$refs.tree.getCheckedNodes();
          this.onlySelectOneObj = _checkedarea[0];
        }else{
          // _checkedarea = this.getTreeChecked();
          var _checkedMaxLenght = this.checkedMaxLenght;
          if(_checkedMaxLenght != null && _checkedMaxLenght != ''){
            _checkedMaxLenght = parseInt(_checkedMaxLenght);
            if(_checkedarea.length >= _checkedMaxLenght){this.isShowCheckedMaxTips = true;}
          }
          _checkedMaxLenght = null;
        }
      }
      _checkedarea = null;

    },

    treeFilter(list, res = []) {
      for (let i = 0; i < list.length; i++) {
        if (Number(list[i].Gpno) === Number(this.areaid)) {
          res.push(list[i]);
          break;
        }

        if (list[i].Childs && list[i].Childs.length > 0) {
          list[i].Childs = this.treeFilter(list[i].Childs, res);
        }
      }

      // list.forEach((item, index) => {
      //   if (Number(item.Gpno) === Number(this.areaid)) {
      //     res.push(item);
      //   };

      //   if (item.Childs && item.Childs.length > 0) {
      //     item.Childs = this.treeFilter(item.Childs, res);
      //   }
      // });
    },

		/* 查询树形数据
		*/
		doFindUserAreaTree(gpNo){
      this.isloading=true;
      if(this.areaSelf == true){
        if(gpNo != null){
          console.log('tree123')
          FindArea({'gpNo': gpNo},this.functionDoFindUserAreaTree);
        }else{
          FindArea({},this.functionDoFindUserAreaTree);
        }
        return;
      }
      if(gpNo != null){
        FindUserAreaTree({'gpNo': gpNo},this.functionDoFindUserAreaTree);
      }else{
        FindUserAreaTree({},this.functionDoFindUserAreaTree);
      }
		},
		/* 树形数据塞入容器
		*/
		addArry(model, fmodel, isof,isTopLevel = false) {
			//通过接口获取到的数据放入区域树model 当前对象 fmodel父对象
			//console.log(model);
      var tempmodel = {},_checkedarea = this.checkedarea;
      if(this.onlySelectOne == true && this.checkedarea != null && this.checkedarea.length>1){
        _checkedarea = [this.checkedarea[0]];
      }
			tempmodel.id = model.Gpno;
			tempmodel.label = model.GpName;
      tempmodel.Level = model.Level;
      tempmodel.IsLeaf = model.IsLeaf;
      if(this.limitLevel != null){
        // if(this.limitAreaids.indexOf(tempmodel["id"])>=0 || this.limitLevel.indexOf(tempmodel.Level)>=0){
        if(this.limitAreaids.indexOf(tempmodel["id"])>=0 || !tempmodel.IsLeaf){
          tempmodel.disabled = true;
        }
      }

      if(this.checkedarea.length == 0 && tempmodel.Level < 2){
        this.expandedarea.push(tempmodel.id);
      }
			if (model.Childs) {
				if(isof == true){

					tempmodel.disabled = true;
					this.checkedarea.push(model.Gpno);
        }
				if (model.Childs.length > 0) {
					tempmodel.children = [];

					model.Childs.forEach((item, index) => {

						this.addArry(item, tempmodel.children, isof || !(_checkedarea.indexOf(model.Gpno)<0),false);
					});
				}
			}
			if(tempmodel.id!=0){
				fmodel.push(tempmodel);
			}
		},
		/* 查询树节点
		*/
		filterNode(value, data) {
      
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},
		/* 点击复选框 给调用的页面发送选中的数据
		*/
		handleCheckChange(data, checked, indeterminate) {
      console.log('onlySelectOne', this.onlySelectOne);
      
      if(this.onlySelectOne == true){
        if(this.onlySelectOneObj != null){
          if(this.onlySelectOneObj != data){
            var dd = this.$refs.tree.getNode(this.onlySelectOneObj);
            dd.checked = false;
            dd = null;
            this.dealTreeOnceChecked(this.onlySelectOneObj.children, false, this);
            this.onlySelectOneObj = data;
          }else{
            this.onlySelectOneObj = null;
          }
        }else{
          this.onlySelectOneObj = data;
        }
      }else{
        this.isShowCheckedMaxTips = false;
        var _checked = data.checked;
        var _checkedMaxLenght = this.checkedMaxLenght;
        if(_checkedMaxLenght != null && _checkedMaxLenght != ''){
          _checkedMaxLenght = parseInt(_checkedMaxLenght);
          var treeChecked = this.getTreeChecked();
          if(data.checked == true && treeChecked != null && treeChecked.length > 0 && treeChecked.length >= _checkedMaxLenght){
            this.isShowCheckedMaxTips = true;
            if(treeChecked.length > _checkedMaxLenght){
              var dd = this.$refs.tree.getNode(data);
              dd.checked = false;
              dd = null;
              data.checked = false;
              this.getTreeChecked();
              return;
            }
          }
          treeChecked = null;
        }
        // 禁止跨区域选择地区 过滤
        if(_checked  && this.noSupportCrossLevel ){
          const array = this.getTreeChecked();
          for(let i=0;i<array.length;i++){
            const { Level } = array[i];
            if(data.Level !==Level){
              var dd = this.$refs.tree.getNode(data);
              dd.checked = false;
              dd = null;
              data.checked = false;
              this.getTreeChecked();
              this.$emit('noSupportCrossLevelTips')
              return
            }
          }
        }
        _checkedMaxLenght = null;
      }
      if(data.checked == true){
         this.dealTreeOnceChecked(data.children, true, this);
      }else{
        this.dealTreeOnceChecked(data.children, false, this);
      }
      this.getTreeChecked();


			// console.log(checked.checkedNodes);
			// console.log(this.$refs.tree.getCheckedKeys())
      //this.GpNos = this.$refs.tree.getCheckedKeys();
      // if(this.onlySelectOne == true){
      //   if(this.onlySelectOneObj != null){
      //     this.dealTreeOnceChecked(this.onlySelectOneObj.children, false, this);
      //   }
      //   // var _checked, dd = this.$refs.tree.getCheckedNodes();

      //   this.onlySelectOneObj = data;
      //   if(checked == true){
      //     this.dealTreeOnceChecked(data.children, true, this);
      //   }
      // }else{
      //   if(checked == true){
      //     this.dealTreeOnceChecked(data.children, true, this);
      //   }else{
      //     this.dealTreeOnceChecked(data.children, false, this);
      //   }
      // }
      this.updataAreaList()
		},
    updataAreaList(){
      this.$emit("getarealist",this.getTreeChecked());
      setTimeout(param => {
        this.$emit("getarealist",this.getTreeChecked());
      }, 500);
    },
    roleUseCheckChange(data, checked, indeterminate){
      data.checked = checked;

      // if(checked == true){
      //   this.dealTreeOnceChecked(data.children, true, this);
      // }else{
      //   this.dealTreeOnceChecked(data.children, false, this);
      // }
      // this.$emit("getarealist",this.getTreeChecked());
	  },
	getTreeChecked(){
    this.treeCheckedArea = '';
    
		var dataArray=[], iswrite = false, dd = this.$refs.tree?.getCheckedNodes();
      	dd = dd?.forEach(item => {
        if(item.disabled != true){
          dataArray.push(item);
          if(item["label"] != null){
            this.treeCheckedArea += item["label"] + ',';
            iswrite = true;
          }
        }
    });
    if(iswrite == true){this.treeCheckedArea = this.treeCheckedArea.substr(0,this.treeCheckedArea.length-1);}

    if(dataArray.length>0 && this.showCancelChoose){
      const {Level} = dataArray[0];
      if(this.LevelMap[Level]){
        this.$t('ifttt.createUp3').replace(/\${{n}}/, this.MaxCount)
        this.treeCheckedArea = this.LevelMap[Level]+ '(' + this.$t('energyBoard.selectAreaType').replace(/\${{n}}/, dataArray.length) +')'
      }
    }
    dd = this.checkedMaxLenght;
    if(dd != null && dd != ''){
      dd = parseInt(dd);
      if(dataArray.length >= dd){
        this.isShowCheckedMaxTips = true;
      }else{
        this.isShowCheckedMaxTips = false;
      }
    }
    dd = null;
    iswrite = null;
	  return dataArray;
	},
    dealTreeOnceChecked(arrMenus, isof, self){
                arrMenus === undefined ?  arrMenus=[]:''
                if(arrMenus.length > 0){
                    arrMenus.forEach(item => {
                        let arrChildren = item.children;
                        var dd = self.$refs.tree.getNode(item);
                        if(dd.checked == true){
                          dd.checked = false;
                        }
                        
                        item.disabled = isof;
                        item.checked = dd.checked;
                        self.$refs.tree.setChecked(item, isof,false);
                        if(arrChildren  != null){
                          this.dealTreeOnceChecked(arrChildren, isof, self)
                        }
                        // item.id === this.currNodeId ?  item.disabled = true :'';
                    })
                }
    }

	}
};
</script>

<style lang="scss" scoped>
.cancel_select_div{
  color:#3F9EFF;
  text-align: right;
  padding: 0px 15px 0px 0px;
  cursor: pointer;
}
.ly-tree-container{
  margin-top: 10px;
}
.limite_header{
  padding-top: 0px !important;
}
.search_limit .input--kaede{
  height: 50px !important;
}
.input__label-content--kaede{
  line-height: 50px;
}
.blue_header{
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  justify-content: center;
}

</style>
